import { useEffect, useState } from 'react'

import { BuildInfo, getBuildInfo } from 'services/build-info'

export function useBuildInfo() {
	const [buildInfo, setBuildInfo] = useState<BuildInfo | null>(null)

	useEffect(() => {
		getBuildInfo()
			.then(data => setBuildInfo(data as unknown as BuildInfo))
			.catch(() => {})
	}, [])

	return buildInfo
}
